import './loadingCardGroup.scss';

import uniqueId from 'lodash/uniqueId';
import { ReactNode, useMemo } from 'react';

import { LoadingCard } from '../LoadingCard/LoadingCard';
import { LoadingCardGroupProps } from './types/LoadingCardGroupProps';

export const LoadingCardGroup = ({
  loadingCount,
  testId,
}: LoadingCardGroupProps): ReactNode => {
  const loadingCardKeys = useMemo(
    (): string[] =>
      Array.from({ length: loadingCount }, (): string =>
        uniqueId('loading-card-'),
      ),
    [loadingCount],
  );

  return (
    <ul className="loading-card-group" data-testid={testId}>
      {loadingCardKeys.map(
        (loadingCardKey): ReactNode => (
          <LoadingCard key={loadingCardKey} />
        ),
      )}
    </ul>
  );
};
